import { imgUser } from '@/assets/images';
import { Stack } from '@/components/layout';
import { Avatar, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { EventDetailInfoRow } from '@/features/guardian/components/event-detail/event-detail-info-row';
import type { FamilyEvent } from '@/features/guardian/family-events';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors, type ColorToken } from '@/theme/colors';

const strings = STRINGS.guardian.kids.eventDetail;

type EventDetailGuestRowProps = {
  event: FamilyEvent;
};

export function EventDetailGuestRow({ event }: EventDetailGuestRowProps) {
  const { scale } = useScaling();
  const styles = useStyles();
  const levelColor = colors[`Level ${event.playerLevel ?? 9}` as ColorToken] ?? colors['Level 9'];

  return (
    <EventDetailInfoRow icon="IcGuest">
      <Stack gap={scale(8)}>
        <Text variant="Font Guardian App/Subtitle/Subtitle 14 Semibold" style={styles.text}>
          {strings.guestCount(1)}
        </Text>
        <Stack direction="row" align="center" gap={scale(8)}>
          <Avatar size={scale(40)} borderWidth={0} activeOpacity={1}>
            <Avatar.Image
              source={event.playerAvatar ?? imgUser}
              backgroundColor={guardianColors['2']}
            />
          </Avatar>
          <Stack flex={1} minWidth={0}>
            <Text variant="Font Guardian App/Subtitle/Subtitle 14 Semibold" style={styles.text}>
              {event.playerName}
            </Text>
            {event.playerAge !== undefined ? (
              <Stack alignSelf="flex-start" style={styles.ageBadge}>
                <Text variant="Font Guardian App/Subtitle/Subtitle 11 Semibold" style={styles.text}>
                  {strings.ageBadge.replace('{age}', String(event.playerAge))}
                </Text>
              </Stack>
            ) : null}
          </Stack>
          {event.playerLevel !== undefined ? (
            <Stack
              align="center"
              justify="center"
              gap={scale(10)}
              backgroundColor={levelColor}
              style={styles.levelBadge}>
              <Text
                numberOfLines={1}
                variant="Font Guardian App/Subtitle/Subtitle 10 Semibold"
                style={styles.levelText}>
                {`LEVEL ${event.playerLevel}`}
              </Text>
            </Stack>
          ) : null}
        </Stack>
      </Stack>
    </EventDetailInfoRow>
  );
}

const useStyles = createStyles(({ scale }) => ({
  text: {
    color: guardianColors['10'],
  },
  ageBadge: {
    paddingHorizontal: scale(12),
    paddingVertical: scale(3),
    borderRadius: scale(999),
    borderCurve: 'continuous',
    borderWidth: 1,
    borderColor: guardianColors['3'],
    backgroundColor: colors['0'],
  },
  levelBadge: {
    paddingTop: scale(4),
    paddingRight: scale(8),
    paddingBottom: scale(3),
    paddingLeft: scale(8),
    borderRadius: scale(10),
    borderCurve: 'continuous',
  },
  levelText: {
    color: colors['0'],
  },
}));
